import styled from "@emotion/styled";
import { tablet } from "../../../media";

export const NewMessageContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 16px;
`;

export const NewMessageInner = styled.div`
    box-sizing: border-box;
    border: 2px solid rgba(94, 132, 237, 0.60);
    width: calc(100% - 32px);
    max-width: 800px; /* optional safety max-width */

    ${tablet`
        width: 100%;
        max-width: 720px;
    `}

    display: flex;
    flex-direction: column;
    gap: 8px;

    padding: 16px;
    border-radius: 12px;

    /* Gradient border around solid background */
    background-image:
        linear-gradient(#1e1f22, #1e1f22),
        linear-gradient(0deg, rgba(94, 132, 237, 0.6), rgba(94, 132, 237, 0.6));
    background-origin: border-box;
    background-clip: padding-box, border-box;

    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

    /* Make sure content is nicely centered vertically within 152px */
    justify-content: space-between;
`;

export const NewMessageHeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Badge = styled.div`
    width: 118px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    padding: 6px 10px;
    gap: 4px;

    border-radius: 9999px;
    background: rgba(94, 132, 237, 0.25);
`;

export const BadgeDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 9999px;
    background: #5e84ed;
    flex-shrink: 0;
    margin-bottom: 2px;
`;

export const BadgeText = styled.span`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;

    white-space: nowrap;
`;

export const TimeText = styled.span`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #b7bdcb;
`;

export const MessagePreview = styled.p`
    margin: 0;
    font-family:
        "Custora",
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #e9ecf5;

    /* two-line clamp with ellipsis */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ListenIconWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ListenText = styled.span`
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;
`;

export const ActionsRow = styled.div`
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

/** Left button: text only, no pill background */
export const ViewConversationButton = styled.button`
    border: none;
    background: transparent;
    padding: 8px 4px;
    margin: -8px -4px;
    min-height: 44px;
    touch-action: manipulation;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #5e84ed;

    cursor: pointer;

`;

export const ListenButton = styled.button`
    /* Keep the design width, but let the row control the height */
    width: 93.58759307861328px;
    height: 28px;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    /* ✅ Remove vertical padding so total height stays within the 32px row */
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 16px;
    padding-right: 16px;

    border-radius: 9999px;
    border: none;

    background: #2b2d33;
    opacity: 1;

    cursor: pointer;

    img {
        display: block;
        width: 16px;
        height: 16px;
    }
`;
